export default "/kiban/_next/static/images/ellipsis-d57632d9b1b57573a00644c34f93eae0.png";